import { render, staticRenderFns } from "./total-Number.vue?vue&type=template&id=538e125e&scoped=true&"
import script from "./total-Number.vue?vue&type=script&lang=js&"
export * from "./total-Number.vue?vue&type=script&lang=js&"
import style0 from "./total-Number.vue?vue&type=style&index=0&id=538e125e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538e125e",
  null
  
)

export default component.exports